// import { createStore, applyMiddleware, compose } from 'redux';
// import reducer from '../modules/reducer'
// import thunkMiddleware from 'redux-thunk';

var createStore = require('redux').createStore;
var applyMiddleware = require('redux').applyMiddleware;
var compose = require('redux').compose;
var reducer = require('../modules/reducer');
var thunkMiddleware = require('redux-thunk').default;

const enhancer = compose(
  applyMiddleware(
    thunkMiddleware
  )
);

var store = createStore(
  reducer,
  {},
  enhancer
);

module.exports = store;



// WEBPACK FOOTER //
// ./src/modules/store.js